import React from 'react';
import * as styles from './PostActions.module.scss';
import PostEditButton from './PostEditButton';
import useAppSelector from '../../app/redux/useAppSelector';
import Button from '../../components/Button';
import { gql } from '../../graphql/generated';
import type { DocumentType } from '../../graphql/generated';
import PostModeToggle from '../../topbar/PostModeToggle';
import PostStatus from '../../topbar/PostStatus';
import { externalEditText } from '../../utils/post/externalPost';
import Presence from '../Presence';
import useIsLayoutSize from '../utils/useIsLayoutSize';
import { LayoutSize } from '../utils/useLayoutSize';

const POST_ACTIONS_FRAGMENT = gql(`
  fragment PostActions_post on Post {
    id
    externalPost {
      id
      editUrl
      platform
    }
    ...PostEditButton_post
  }
`);

interface PostActionsProps {
  post: DocumentType<typeof POST_ACTIONS_FRAGMENT>;
}

const PostActions = ({ post }: PostActionsProps) => {
  const isMobileLayout = useIsLayoutSize(LayoutSize.mobile);
  const readOnly = useAppSelector((state) => state.editor.readOnly);

  return (
    <>
      {isMobileLayout ? (
        <>
          <PostModeToggle mobile />
          <PostEditButton post={post} mobile />
        </>
      ) : (
        <>
          <div className={styles.statusContainer}>
            {!readOnly && <PostStatus />}
          </div>
          <div className={styles.presenceContainer}>
            <Presence />
          </div>
          {post.externalPost ? (
            <Button
              variant="secondary"
              to={post.externalPost.editUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {externalEditText(post.externalPost.platform)}
            </Button>
          ) : (
            <PostModeToggle />
          )}
          <div className={styles.modeToggleSeparator} />
          <PostEditButton post={post} />
        </>
      )}
    </>
  );
};

export default PostActions;
